import { motion } from "framer-motion";
import { TECH_STACK } from "../../lib/data";

export default function TechStack() {
    return (
        <section
            data-testid="tech-stack-section"
            id="tech-stack"
            className="relative py-24 md:py-32 bg-secondary/30"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="mb-16 max-w-2xl">
                    <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                        Engineering stack
                    </div>
                    <h2 className="font-display font-light text-4xl md:text-5xl tracking-tighter leading-tight">
                        Modern technologies,{" "}
                        <span className="italic font-medium">
                            chosen deliberately
                        </span>
                        .
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {Object.entries(TECH_STACK).map(([group, items], gi) => (
                        <motion.div
                            key={group}
                            initial={{ opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: gi * 0.08 }}
                            data-testid={`tech-group-${gi}`}
                            className="p-8 rounded-2xl border border-border bg-card"
                        >
                            <div className="text-xs uppercase tracking-widest text-muted-foreground mb-6">
                                {group}
                            </div>
                            <div className="flex flex-wrap gap-2">
                                {items.map((t) => (
                                    <span
                                        key={t}
                                        className="px-3 py-1.5 rounded-full bg-foreground/5 dark:bg-background/10 text-sm border border-border/70"
                                    >
                                        {t}
                                    </span>
                                ))}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
